export default __webpack_public_path__ + "static/media/LexModelsV2.01b58771.svg";